import React from 'react';
import styled from '@emotion/styled';

import { ContentBox } from '../layout/content-box';

const StyledEmptyState = styled.div`
  padding: 25px 10px;
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const EmptyState = ({ children }) => {
  return (
    <StyledEmptyState>
      <ContentBox solidBackground>{children}</ContentBox>
    </StyledEmptyState>
  );
};

export default EmptyState;
